const doc = [({"en":({"adminConstantHotelDisplayPriceType":({"totalAndPricePerPerson":"Total and price per person", "totalPriceOnly":"Total price only"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;